export default "__VITE_ASSET__1HgU8C_T__"